/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { configureStore } from "@reduxjs/toolkit";
import tenantSlice from "./Tenant/tenant-slice";
import userSlice from "./User/user-slice";
import organizationSlice from "./Organization/organization-slice";
import organisationSlice from "./Organisation/organisation-slice";
import themeSlice from "./theme/themeSlice";

const store = configureStore({
  reducer: {
    cart: tenantSlice.reducer,
    user: userSlice.reducer,
    organization: organizationSlice.reducer,
    organisation: organisationSlice.reducer,
    theme: themeSlice,
  },

  devTools: process.env.NODE_ENV !== "production",
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
